import React, { useState } from 'react';
import { Button, KIND, SIZE } from 'baseui/button';
import { type Value, Select } from 'baseui/select';
import { SIZE as TEXT_AREA_SIZE, Textarea } from 'baseui/textarea';
import { useAtom, useAtomValue } from 'jotai';
import { commentsAtom, commentSelectOptionsAtom, reviewAnnotationsAtom } from '../atoms';
import { REVIEW_COMMENT_SOURCE } from '../constants';
import useAnalyticsForReviewSidePanel from '../hooks/useAnalyticsForReviewSidePanel';
import type { ReviewCommentT } from '../types';
import { ModalBody, ModalFooter } from './styled-components';
type Props = {
  onClose: () => void;
  annotationId?: string;
  commentId?: number;
};
export const AddComment = ({
  onClose,
  annotationId,
  commentId
}: Props) => {
  const commentSelectOptions = useAtomValue(commentSelectOptionsAtom);
  const [comments, setComments] = useAtom(commentsAtom);
  const reviewAnnotations = useAtomValue(reviewAnnotationsAtom);
  const {
    sendEventReviewAnnotationNote
  } = useAnalyticsForReviewSidePanel();

  // To handle update comment case
  if (commentId !== undefined) {
    annotationId = comments[commentId]?.annotationId;
  }
  const [value, setValue] = useState<Value>([
  // @ts-expect-error todo(ts-migration) TS2322 Type '{ id: string; value: string; level: ReviewCommentLevelT; } | undefined' is not assignable to type 'Readonly<{ [x: string]: any; id?: string | number | undefined; label?: ReactNode; disabled?: bo...
  annotationId ? commentSelectOptions.find(option => option.id === annotationId) ?? commentSelectOptions[0] : commentSelectOptions[0]]);
  const [commentValue, setCommentValue] = useState<string>(commentId !== undefined ? comments[commentId]?.comment ?? '' : '');
  const handleAddComment = () => {
    const finalAnnotationId = (value[0]?.id as string);
    const annotation = finalAnnotationId ? reviewAnnotations[finalAnnotationId] : undefined;
    const newComment: ReviewCommentT = {
      annotationId: finalAnnotationId,
      comment: commentValue,
      source: REVIEW_COMMENT_SOURCE.HUMAN,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      level: value[0].level
    };
    if (commentId !== undefined) {
      setComments(prev => {
        const newComments = [...prev];
        newComments[commentId] = newComment;
        return newComments;
      });
    } else {
      setComments(prev => [...prev, newComment]);
    }
    if (annotation && finalAnnotationId && commentValue) {
      sendEventReviewAnnotationNote({
        objectId: finalAnnotationId,
        objectType: annotation.type || 'unknown',
        label: annotation.label || annotation.name || '',
        note: commentValue
      });
    }
    onClose();
  };
  return <ModalBody>
      <Select options={commentSelectOptions} labelKey="value" valueKey="id" value={value} onChange={({
      value
    }) => setValue(value)} clearable={false} />
      <Textarea id="comment-textarea" size={TEXT_AREA_SIZE.mini} placeholder="Enter your comment here" clearable value={commentValue} onChange={e => {
      e.stopPropagation();
      setCommentValue(e.target.value);
    }} />
      <ModalFooter>
        <Button kind={KIND.tertiary} size={SIZE.small} onClick={onClose}>
          Cancel
        </Button>
        <Button kind={KIND.primary} size={SIZE.small} disabled={!commentValue} onClick={handleAddComment}>
          Add Comment
        </Button>
      </ModalFooter>
    </ModalBody>;
};